import {Fragment, observer, React, useAsObservableSource} from '@api'
import {Actions, FloatingWindow, FloatingWindowTab, LayoutStore, Tab, TabFloating, TabNode, useLayoutStore} from '@flexlayout'
import {action, computed, trace} from 'mobx'

/// region Store

export class FloatingTabsStore {
  constructor(public store: LayoutStore) {
  }

  get model() { return this.store.model}

  // @computed get floatingBorderTabs() {
  //   const {store: { tabs: {tabs}, supportsPopout}} = this
  //   if (!supportsPopout) return []
  //
  //   borderTabs.filter(t => t.isFloating).map(() => {})
  // }
  //
  // @computed get floatingMainTabs() {
  //   const {store: {supportsPopout}} = this
  //   if (!supportsPopout) return []
  //
  //   return []
  // }

  @computed get floatingTabs() {
    const {store: {visibleTabs}} = this
    const r = visibleTabs.filter(t => t.isFloating)

    return r
  }

  /** @hidden @internal */
  @action onCloseWindow = (id: string) => {
    const {store: {doAction, model}} = this
    doAction(Actions.unFloatTab(id))
    try {
      (model.nodeById(id) as TabNode)._setWindow(undefined)
    } catch (e) {
      // catch incase it was a model change
    }
  }
  /** @hidden @internal */
  @action onSetWindow = (id: string, window: Window) => {
    (this.model.nodeById(id) as TabNode)._setWindow(window)
  }
}

/// endregion

export const FloatingWindows = observer(function FloatingWindows() {
  const {floatingTabs: {floatingTabs}} = useLayoutStore()

  return (<Fragment>
    {floatingTabs.map(child => <FloatingWindowWrapper key={child.id} node={child} />)}
  </Fragment>)
})

const FloatingWindowWrapper = observer<{ node: TabNode }>(function FloatingWindowWrapper({node}) {
    const {floatingTabs: {store, onSetWindow, onCloseWindow}} = useLayoutStore()

  // Expensive to do on every render
  const rect = store._getScreenRect(node)

  return (
    <FloatingWindow
    url={store.props.popoutURL}
    rect={rect}
    title={node.name}
    id={node.id}
    onSetWindow={onSetWindow}
    onCloseWindow={onCloseWindow}
  >
    <FloatingWindowTab layout={store} node={node} factory={store.props.factory}/>
  </FloatingWindow>)
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/FloatingWindows.tsx